import React, { useContext, useEffect } from "react"
// import Seo from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Seo"
import Header from "./Header"
import { Helmet } from "react-helmet"
import Footer from "./Footer"

import ScrollUpButton from "../molecules/ScrollUpButton"

import { NavContext } from "@yumgmbh/gatsby-plugin-sb-nav/src/context/NavContext"
import { changeLanguage } from "i18next"

import { privacyLinks } from "../../utilities/privacy-links"

const Layout = ({ children, language }) => {
  const { navData } = useContext(NavContext) || { navData: {} }

  // set i18n-language
  // set klaro-language
  useEffect(() => {
    changeLanguage(language)
    if (typeof window !== "undefined") {
      if (window.klaro && window.klaro.render && window.klaroConfig) {
        //window.klaro.defaultConfig.lang = language

        setTimeout(() => {
          window.klaro.render({
            ...window.klaroConfig,
            ...{ lang: language },
            ...{ privacyPolicy: { default: privacyLinks[language] } },
          })
          if (window.klaro.getManager) {
            let manager = window.klaro.getManager()
            manager.applyConsents()
          }
          if (document?.location?.pathname === "/storyblok-preview/") {
            setTimeout(() => {
              if (document.querySelector(".cm-btn.cm-btn-success")) {
                document.querySelector(".cm-btn.cm-btn-success").click()
              }
            }, 100)
          }
        }, 50)
      }
    }
  }, [language, children])

  return (
    <>
      <Header navData={navData?.mainNavigation?.navigation} />
      {/* <Seo title="Test"></Seo> */}
      <Helmet
        htmlAttributes={{ lang: language }}
        bodyAttributes={{
          class: "theme-default",
        }}
      >
        <meta
          name="google-site-verification"
          content="3P_J3mHSlR3wiQtlxoe9HwSATjk8wOAzpXRhg942YoU"
        />
        <script
          type="text/plain"
          data-name="googleanalytics"
          data-type="application/javascript"
        >
          {` (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','${process.env.GATSBY_GTM_KEY}');`}
        </script>
        <script
          type="text/plain"
          data-name="clarity"
          data-type="application/javascript"
        >
          {`(function(c,l,a,r,i,t,y){ c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)}; t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i; y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y); })(window, document, "clarity", "script", "p52h4ijet5");`}
        </script>
        <script
          type="text/plain"
          data-name="getsitecontrol"
          data-type="text/javascript"
          async
          src="//l.getsitecontrol.com/94mymvo4.js"
        ></script>
      </Helmet>
      <main>{children}</main>
      <ScrollUpButton />
      <Footer navData={navData?.footer?.navigation} />
    </>
  )
}

export default Layout
